import React, {Component} from 'react'
import {Label, Input} from 'reactstrap'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import {withApollo} from 'react-apollo'

class FilterWpsSwitch extends Component {
  constructor(props) {
    super(props)
    this.state = {
      switch_on: localStorage.getItem('weldsGridFilterWps') === 'true'
    }

    this.handleSwitch = this.handleSwitch.bind(this)
  }

  static propTypes = {
    client: PropTypes.object.isRequired,
    weld_id: PropTypes.number.isRequired,
    updateWpsData: PropTypes.func.isRequired
  }

  componentWillMount() {
    this.state.switch_on && this.fetchWpsData()
  }

  handleSwitch() {
    this.setState({switch_on: !this.state.switch_on}, () => {
      if (this.state.switch_on) {
        this.fetchWpsData()
      } else {
        this.props.updateWpsData(null)
      }
    })
  }

  fetchWpsData() {
    this.props.client.query({
      query: WpsForWeldFetchQuery,
      fetchPolicy: 'network-only',
      variables: {weld_id: this.props.weld_id}
    }).then(({data}) => {
      this.props.updateWpsData(data.wps_by_weld)
    })
  }

  render() {
    return (
      <div style={{fontWeight: 400}} className="float-right">
        &nbsp; Filter by weld requirements &nbsp;
        <Label id="show-welders-switch" className="switch switch-sm switch-text switch-info mb-0">
          <Input type="checkbox" className="switch-input"
            checked={this.state.switch_on}
            onChange={this.handleSwitch}/>
          <span className="switch-label" data-on="On" data-off="Off"/>
          <span className="switch-handle"/>
        </Label>
      </div>
    )
  }
}

const WpsForWeldFetchQuery = gql`
  query WpsForWeldQuery($weld_id: Int!) {
    wps_by_weld(weld_id: $weld_id) {
      id
      no
      rev_no
      actual
    }
  }
`

export default withApollo(FilterWpsSwitch)



// WEBPACK FOOTER //
// ./src/components/Welds/helpers/wps/FilterWpsSwitch.js